import { render, staticRenderFns } from "./SocialInfo.vue?vue&type=template&id=610c5074&"
import script from "./SocialInfo.vue?vue&type=script&lang=js&"
export * from "./SocialInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports